import { motion } from 'framer-motion'
import { AppTabsProps } from '@/shared/ui/appTabs'
import { useStyles } from './styles'
import { Icon } from '@/shared/ui/icon'

export const LeaderboardTabs = (props: AppTabsProps) => {
  const { classes } = useStyles()
  const { tabs, activeValue, onChange } = props

  return (
    <div className={classes.root}>
      {tabs.map((tab) => {
        const isActive = activeValue === tab.value

        return (
          <div
            className={classes.tab}
            key={tab.value}
            onClick={() => onChange(tab.value)}
            style={{ position: 'relative' }}
          >
            {isActive && (
              <motion.div
                layoutId="active-tab-indicator"
                className={classes.activeContainer}
                transition={{
                  type: 'spring',
                  stiffness: 500,
                  damping: 45,
                }}
              />
            )}
            <Icon
              view={tab.icon}
              style={{ zIndex: '2' }}
            />
            <span>{tab.label}</span>
          </div>
        )
      })}
    </div>
  )
}
